import { GrispiInputProps } from '..';
import QuillGrispiRichTextEditor from '../../QuillGrispiRichTextEditor';
import GrispiInputContainer from '../GrispiInputContainer';

type GrispiRichTextInputProps = Omit<GrispiInputProps<'HTML'>, 'type' | 'options' | 'isNewValueAllowed'>;

const GrispiRichTextInput = ({ containerProps, disabled, onChange, value, ...rest }: GrispiRichTextInputProps) => {
    return (
        <GrispiInputContainer {...containerProps}>
            <QuillGrispiRichTextEditor onChange={onChange} readOnly={disabled} simpleEditor value={value} {...rest} />
        </GrispiInputContainer>
    );
};

export default GrispiRichTextInput;
